import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', 'Open Sans', 'Helvetica', Helvetica, Arial, sans-serif;
    background-color: ${({ theme }) => theme.colors.N10};
    color: ${({ theme }) => theme.colors.N70};
  }

  @media only screen and (max-width: 600px) {
    .hide-mobile {
      display: none;
    }
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 300;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  code {
    color: #333; // Since background is light in both dark and light
  }

  textarea {
    color: #333; // Since background is light in both dark and light
  }

  .mapboxgl-popup-tip,
  .mapboxgl-popup-content {
    color: #555; // Theme independent for now.
  }

`;
